var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isRealtruckBrand(this.brand))?_c('div',{staticClass:"flex items-center overflow-hidden"},[_c('img',{attrs:{"src":require("@/assets/common/the-r.svg"),"alt":"","width":"28","height":"26"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }